export const SET_USERS_TRASH = "SET_USERS_TRASH";
export const GET_USERS_TRASH = "GET_USERS_TRASH";
export const REFRESH_USERS_TRASH = "REFRESH_USERS_TRASH";